module.exports = __webpack_public_path__ + "static/media/largeHallRestrau.e5344e83.png";